// src/contexts/AuthContext.js

import React, { createContext, useState } from 'react';
import { Navigate } from 'react-router-dom';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authTokens, setAuthTokens] = useState(() => {
    const access = localStorage.getItem('access_token');
    const refresh = localStorage.getItem('refresh_token');
    return { access, refresh };
  });

  const setTokens = (data) => {
    localStorage.setItem('access_token', data.access);
    localStorage.setItem('refresh_token', data.refresh);
    setAuthTokens(data);
  };

  const logout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    setAuthTokens(null);
    return <Navigate to="/" />;
  };

  return (
    <AuthContext.Provider
      value={{ authTokens, setAuthTokens: setTokens, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};
